import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';
import type { ItemType } from '@/types/api';
import { ITEM_TYPES, ITEM_TYPE_LABEL_KEY } from '@/lib/itemTypeConfig';

interface TypeSegmentProps {
  value: ItemType;
  onChange: (next: ItemType) => void;
  options?: ItemType[];
  className?: string;
}

const DEFAULTS: ItemType[] = [...ITEM_TYPES];

export function TypeSegment({
  value,
  onChange,
  options = DEFAULTS,
  className,
}: TypeSegmentProps) {
  const { t } = useTranslation();
  return (
    <div
      role="radiogroup"
      aria-label={t('addStock.itemType')}
      className={cn(
        'flex flex-wrap gap-0.5 rounded-md border border-line bg-paper-2 p-[3px]',
        className,
      )}
    >
      {options.map((opt) => {
        const on = opt === value;
        return (
          <button
            key={opt}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => onChange(opt)}
            className={cn(
              'flex h-[30px] flex-1 min-w-[80px] items-center justify-center rounded-[7px] px-2 text-[12px] tracking-[-0.01em] transition-colors',
              on
                ? 'bg-paper border border-line font-semibold text-ink'
                : 'bg-transparent border border-transparent font-medium text-muted hover:text-ink-2',
            )}
          >
            {t(ITEM_TYPE_LABEL_KEY[opt])}
          </button>
        );
      })}
    </div>
  );
}
